// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rZ8mZ","questions":"styles_questions__1acMR","footer":"styles_footer__2Ssa3"};